var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center mx-2 md:mx-10 md:mt-10"},[_c('div',{staticClass:"p-0 rounded border border-solid border-cyan-500 w-full max-w-[1170px]"},_vm._l((_vm.entries),function(ref){
var title = ref.title;
var body = ref.body;
var _uid = ref._uid;
return _c('BaseAccordion',{key:_uid,attrs:{"title":title,"titleLeft":""}},[_c('div',{staticClass:"accordion-content my-5 mx-4 md:mx-11 tracking-[.39] leading-[22px]"},[(body)?_c('RichTextRenderer',{attrs:{"document":body}}):_vm._e()],1)])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }